import { render, staticRenderFns } from "./SectionError.vue?vue&type=template&id=fbf7137c&scoped=true"
import script from "./SectionError.vue?vue&type=script&lang=js"
export * from "./SectionError.vue?vue&type=script&lang=js"
import style0 from "./SectionError.vue?vue&type=style&index=0&id=fbf7137c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf7137c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbf7137c')) {
      api.createRecord('fbf7137c', component.options)
    } else {
      api.reload('fbf7137c', component.options)
    }
    module.hot.accept("./SectionError.vue?vue&type=template&id=fbf7137c&scoped=true", function () {
      api.rerender('fbf7137c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/SectionError.vue"
export default component.exports